import Backbone from 'backbone'
import _ from 'lodash'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'

/**
 * Calendar period selector customized for use by widgets that can set a
 * specific calendar period (eg speedometers, linear gauges, shapes)
 */
const WidgetPeriodSelector = Backbone.View.extend({

	/** @type {WidgetModel} */
	model: null,

	initialize: function (options) {
		this.options = options
	},

	render: function() {
		let range = {
			calendarId: this.model.properties.get('calendarId')
		}

		if (_.isNil(this.model.properties.get('periodId'))) {
			range.relative = true
			range.first = range.last = (this.model.properties.get('periodDelta') || 0)
		} else {
			range.relative = false
			range.first = range.last = this.model.properties.get('periodId')
		}

		this.periodSelector = new CalendarRangeSelector({
			range: range,
			canChangeCalendar: true,
			singlePeriod: true,
			allowAppCalendar: true
		})

		this.$el.append(this.periodSelector.el)

		this.periodSelector.render()

		return this
	},

	val () {
		let { first, relative, calendarId } = this.periodSelector.val()
		let update = { calendarId }

		if (relative) {
			update.periodDelta = first
			update.periodId = null
		} else {
			update.periodDelta = null
			update.periodId = first
		}

		return update
	}
})

export default WidgetPeriodSelector

WidgetPeriodSelector.__filename__ = 'dashboards/widgets/widget-period-selector.js'
